import React, { useMemo } from 'react';
import { ExarePriceDetailsPriceElementType } from '@websky/graphql';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
import PriceItem from '../PriceItem/PriceItem';
import TotalRefund from '../TotalRefund/TotalRefund';
import { getTotalPriceFilteredElements, getZeroPrice } from '../../utils';
const ShortDetails = ({ prices, ticketPrice, className, items }) => {
    const { t } = useTranslation('Refund');
    const { ShortDetails: css } = useTheme('PriceDetails');
    const details = useMemo(() => {
        var _a;
        if (items) {
            return items;
        }
        const detailsItems = [];
        const priceDetails = prices.priceDetails;
        const currentCurrency = (_a = prices.basePrice) === null || _a === void 0 ? void 0 : _a.currency;
        detailsItems.push({
            name: `${t('Ticket price')}:`,
            price: prices.basePrice || getZeroPrice(currentCurrency)
        });
        detailsItems.push({
            name: t('Cost of refundable services'),
            price: getTotalPriceFilteredElements(priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.refunded.elements, ExarePriceDetailsPriceElementType.gdsServiceFare, currentCurrency)
        });
        detailsItems.push({
            name: t('Cost of non-refundable services'),
            price: getTotalPriceFilteredElements(priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.retention.elements, ExarePriceDetailsPriceElementType.gdsServiceFare, currentCurrency),
            isMinus: true
        });
        detailsItems.push({
            name: t('Fare refund penalty'),
            price: getTotalPriceFilteredElements(priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.retention.elements, ExarePriceDetailsPriceElementType.taxesRetention, currentCurrency),
            isMinus: true
        });
        return detailsItems;
    }, [t, prices, ticketPrice, items]);
    return (React.createElement("div", { className: cn(css.root, className) },
        React.createElement("div", { className: css.details }, details.length > 0 &&
            details.map((detail, index) => (React.createElement(PriceItem, { key: index, className: css.item, name: detail.name, price: detail.price, isMinus: detail.isMinus })))),
        React.createElement(TotalRefund, { className: css.totalRefund, price: prices.priceToPay })));
};
export default ShortDetails;
